import React from 'react'
import type { IconsProps } from '../types'

const ArrowLeft = ({ fill = '#0D0D0D' }: IconsProps) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.53033 0.469671C8.82323 0.762564 8.82323 1.23744 8.53033 1.53033L2.81066 7.24998H15C15.4142 7.24998 15.75 7.58577 15.75 7.99998C15.75 8.4142 15.4142 8.74998 15 8.74998H2.81066L8.53033 14.4697C8.82323 14.7626 8.82323 15.2374 8.53033 15.5303C8.23744 15.8232 7.76256 15.8232 7.46967 15.5303L0.469669 8.53031C0.329017 8.38966 0.25 8.1989 0.25 7.99998C0.25 7.80107 0.329018 7.61031 0.469671 7.46965L7.46967 0.469669C7.76257 0.176776 8.23744 0.176777 8.53033 0.469671Z'
        fill={fill}
      />
    </svg>
  )
}

export default ArrowLeft
